export default {
  title: 'Forgot your password?',
  subTitle: 'Enter your email address below — we’ll send you a link to reset the password.',
};
